module.exports = __webpack_public_path__ + "static/media/different-people.77da0394.jpg";